var prongHorn = prongHorn || {};

prongHorn.productUpgrade = prongHorn.productUpgrade || function() {
    var $trigger = $('.upgrade__input');
    var $triggerWrapper = $('.accordion__line--has-upgrade');
    var $triggerHeading =  $('.accordion__line--has-upgrade .js-title');
    var $dataWrapper = $('#product');
    var origPrice = convertToInt($dataWrapper.data('price'));
    var origWeight = convertToInt($dataWrapper.data('weight'));


    this.init = function() {

        if($triggerWrapper.length) {

            $trigger.on('change', function(){
                updateValues()
            })

            $triggerHeading.on('click', function(){
                toggleAccordion($(this));
            })
            
        }


    };



    // Helpers
    function updateValues() {
        var price = convertToInt($dataWrapper.data('price'));
        var weight = convertToInt($dataWrapper.data('weight'));
        var label = "";

        $triggerWrapper.each(function(){
            var dataPrice = convertToInt($(this).find('input:checked').data('price'));
            var dataWeight = convertToInt($(this).find('input:checked').data('weight'));
            var dataLabel = $(this).find('input:checked').data('label');

            

            price += dataPrice;
            weight += dataWeight;

            // Set the label
            $(this).find('.js-upgrade').html(dataLabel);

        });

        // Format the values
        weight = weight.toFixed(2).replace('.', ',');
        price = price.format(2, 3, '.', ',');

        $('.product__price span').html(price);
        $('.product__total-weight span').html(weight);




    }

    function toggleAccordion($title) {
        var activeClass = 'active';
        var $parent = $title.parent();

        if($parent.hasClass(activeClass)) {
            $parent.removeClass(activeClass)
        } else {
            $parent.addClass(activeClass);
            $parent.siblings().removeClass(activeClass);
        }

    }


    function convertToInt(string) {

        if(string && string.toString().indexOf(',') > -1) {
            // First replace the punctum with a empty space
            var formattedStr = string.replace('.', '').replace(',', '.');
            
            return formattedStr * 1;

        } else {
            // console.log(string * 1);
            return string * 1;
        }

    }

    /*
     * Number.prototype.format(n, x, s, c)
     * 
     * @param integer n: length of decimal
     * @param integer x: length of whole part
     * @param mixed   s: sections delimiter
     * @param mixed   c: decimal delimiter
     */
    Number.prototype.format = function(n, x, s, c) {
        var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
            num = this.toFixed(Math.max(0, ~~n));

        return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
    };


    // Public functions
    return {
        init: init
    };

}(); 

